export const ParameterTypes = ['decimal', 'integer', 'boolean'] as const;
